// extracted by mini-css-extract-plugin
export default {"logoFont":"Logo_logoFont__iLuHM"};